/**
 * @license
 * @preserve
 *
 * KeeeX SAS Confidential
 * https://keeex.me
 * Copyright 2013-2020 KeeeX All Rights Reserved.
 * 
 * These computer program listings and specifications, herein,
 * are and remain the property of KeeeX SAS. The intellectual
 * and technical concepts herein are proprietary to KeeeX SAS
 * and may be covered by EU and foreign patents,
 * patents in process, trade secrets and copyright law.
 * 
 * They shall not be reproduced or copied or used in whole or
 * in part as the basis for manufacture or sale of items unless
 * prior written permission is obtained from KeeeX SAS.
 * 
 * For a license agreement, please contact:
 * <mailto: contact@keeex.net>
 * 
 */
import{getUint8Array as r,buf82str as t,str2buf8 as e,buf82hex as o,hex2buf8 as a,concatenateBuf8List as s,explodeBuf8List as f,merge as n,utf82buf8 as p,buf82utf8 as c,buf8Equal as x,findString as b,findLastString as i,concatenatedBuf8ListSize as u}from"./uint8array.js";import{ab2b64 as g,b642ab as m,getArrayBuffer as B}from"./bits/arraybuffer.js";import{bufferAb2B64 as y,bufferB642Ab as A,haveBufferBase64 as d}from"./utils/buffer.js";export const getArrayBuffer=B;export const ab2str=e=>t(r(e));export const str2ab=r=>getArrayBuffer(e(r));export const ab2hex=(t,e)=>o(r(t),e);export const hex2ab=r=>getArrayBuffer(a(r));export const concatenateBuffersList=(t,e=!1)=>getArrayBuffer(s(t.map((t=>r(t))),e));export const explodeBuffersList=t=>f(r(t)).map((r=>getArrayBuffer(r)));export const concatenatedBuffersListSize=t=>u(r(t));export const merge=t=>getArrayBuffer(n(t.map((t=>r(t)))));export const ab2b64=d()?y:g;export const b642ab=d()?A:m;export const utf82ab=r=>getArrayBuffer(p(r));export const ab2utf8=t=>c(r(t));export const abEqual=(t,e)=>x(r(t),r(e));export const findString=(t,e,o=0)=>b(t,r(e),o);export const findLastString=(t,e,o=0,a=-1)=>i(t,r(e),o,a);